// --- 背景エフェクト ------

const PX_RATIO = window.devicePixelRatio;
const PI2 = Math.PI * 2;

// 色ありの丸
const COLORS = ["#EDC6C6", "#E8DDB1", "#BCD9DB", "#DBD2E5", "#C4D6BD"];    // 円の色
// const BUBBLE_INFOS = [
//   {color: "#EDC6C6", sizeRate: 0.1, centerX: 0.41, centerY: 0.63, direction: -1, angle: 236, radiusOrbitRate: 0.2, move: -0.3},
//   {color: "#E8DDB1", sizeRate: 0.12, centerX: 0.62, centerY: 0.6, direction: 1, angle: 262, radiusOrbitRate: 0.3, move: 0.154},
//   {color: "#BCD9DB", sizeRate: 0.08, centerX: 0.73, centerY: 0.57, direction: -1, angle: 156, radiusOrbitRate: 0.3, move: -0.173},
//   {color: "#DBD2E5", sizeRate: 0.09, centerX: 0.53, centerY: 0.55, direction: -1, angle: -10, radiusOrbitRate: 0.31, move: -0.18},
//   {color: "#C4D6BD", sizeRate: 0.05, centerX: 0.5, centerY: 0.52, direction: 1, angle: 158, radiusOrbitRate: 0.28, move: 0.135}
// ];

const BUBBLE_INFOS = [
  {color: "#EDC6C6", sizeRate: 0.1, centerX: 0.41, centerY: 0.63, direction: -1, angle: 236, radiusOrbitRate: 0.2, move: -0.22},
  {color: "#E8DDB1", sizeRate: 0.12, centerX: 0.62, centerY: 0.6, direction: 1, angle: 262, radiusOrbitRate: 0.3, move: 0.1},
  {color: "#BCD9DB", sizeRate: 0.08, centerX: 0.73, centerY: 0.57, direction: -1, angle: 156, radiusOrbitRate: 0.3, move: -0.12},
  {color: "#DBD2E5", sizeRate: 0.09, centerX: 0.53, centerY: 0.55, direction: -1, angle: -10, radiusOrbitRate: 0.31, move: -0.13},
  {color: "#C4D6BD", sizeRate: 0.05, centerX: 0.5, centerY: 0.52, direction: 1, angle: 158, radiusOrbitRate: 0.28, move: 0.11}
]
const MIN_SPEED_BASE = 0.05;	// 変化量の最低値 - 全体の速さを調整
const VAR_SPEED_BASE = 0.2;	// 変化量をランダムに変化させる設定値 - 各々の速さのばらつきを設定
const cw = window.innerWidth * PX_RATIO;
const ch = window.innerHeight * PX_RATIO;
const MIN_SPEED = Math.floor(MIN_SPEED_BASE / 1366 * Math.max(cw, ch) * 100) / 100;
const VAR_SPEED = Math.floor(VAR_SPEED_BASE / 1366 * Math.max(cw, ch) * 100) / 100;
// const MIN_SPEED = 0.1 * PX_RATIO;
// const VAR_SPEED = 0.2 * PX_RATIO;
const windowType = cw > ch ? 'h' : 'p';
const COUNT_BUBBLES = windowType === 'h' ? 5 : 5;
const OPACITY = 0.7;


class Canvas {
    constructor(containerId, args) {
        if (args === undefined) args = {};
        if (containerId === undefined) this.container = document.body;
        else this.container = document.getElementById(containerId);
        this.canvas = document.createElement("canvas");
        this.container.appendChild(this.canvas);
        this.context = this.canvas.getContext("2d");
        window.addEventListener("resize", () => this.onResize(), false);
        this.onResize();
    }

    setSize() {
        this.canvas.style.width = this.width + "px";
        this.canvas.style.height = this.height + "px";
        this.canvas.width = this.width * PX_RATIO;
        this.canvas.height = this.height * PX_RATIO;
    }

    onResize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.setSize();
        this.center = {
            x: this.canvas.width / 2,
            y: this.canvas.height / 2
        }
    }

    clear() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
	
    stroke(_color) {
        this.context.strokeStyle = _color;
        this.context.stroke();
    }

    background(_fill) {
        if (_fill === undefined) throw new Error('背景色を設定してください');
        this.context.fillStyle = _fill;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }
}

let bubbleCounter = 0;
class Bubble {
	constructor() {
		const cw = window.innerWidth * PX_RATIO;
		const ch = window.innerHeight * PX_RATIO;
		this.x0 = ~~ (BUBBLE_INFOS[bubbleCounter].centerX * cw);  // 回転の中心のx座標
		this.y0 = ~~ (BUBBLE_INFOS[bubbleCounter].centerY * ch);  // 回転の中心のy座標
		this.color = BUBBLE_INFOS[bubbleCounter].color;    // 円の色
		// console.log(this.color);
    const cl = Math.max(cw, ch); // 画面サイズ（width, heightの長い方）
		// this.move = (VAR_SPEED * ~~ (Math.random() * 10) / 10 + MIN_SPEED) * BUBBLE_INFOS[bubbleCounter].direction;
    // console.log(this.move);
    this.move = BUBBLE_INFOS[bubbleCounter].move;
		// this.move = MIN_SPEED;
    // this.angle = ~~ (Math.random() * 360);       // 度数
    this.angle = BUBBLE_INFOS[bubbleCounter].angle;       // 度数
		this.radius = ~~ (cl * BUBBLE_INFOS[bubbleCounter].sizeRate);    // 描画する円の半径
    this.radiusOrbit = ~~ (cl * BUBBLE_INFOS[bubbleCounter].radiusOrbitRate);
    this.direction = BUBBLE_INFOS[bubbleCounter].direction;
        // console.log(this);
		bubbleCounter += 1;
	}
	update() {
		const radian = this.angle * Math.PI/180;
		this.x = ~~ (this.radiusOrbit * Math.cos(radian) + this.x0);
		this.y = ~~ (this.radiusOrbit * Math.sin(radian) + this.y0);
    this.angle += this.move;
    // if (this.direction === -1) {
    //   this.angle -= this.move;
    // } else {
    //   this.angle += this.move;
    // }
    
		if (this.angle > 360) {
			this.angle -= 360;
		} else if (this.angle < 0) {
			this.angle += 360;
		}
	}
	draw(_ctx) {
		this.update();
		_ctx.beginPath();
		_ctx.fillStyle = this.color;
		_ctx.arc(this.x, this.y, this.radius, 0, PI2, false);
		_ctx.globalAlpha = OPACITY;
		_ctx.fill();
		_ctx.closePath();
	}
}


class Blubble extends Canvas {
	constructor(containerId, bubbleNumber) {
		super(containerId);
		this.totalBubbles = bubbleNumber;
		this.bubbles = [];
		// this.ellipses = [];
		this.set();
		this.animate();
	}

	// options_ellipses_pc() { 
	// 	return {
	// 		x0: ~~ (this.canvas.width / 5 * 2),
	// 		y0: ~~ (this.canvas.height / 2),
	// 		color: '#fff',
	// 		// width: ~~ (this.canvas.width * PX_RATIO / 5 * 4 / 2),
	// 		minWidth: ~~ (this.canvas.width / 5 * 2 / 2),
	// 		maxWidth: ~~ (this.canvas.width / 5 * 4 / 2),
	// 		moveWidth: 0.2 * PX_RATIO,
	// 		directionWidth: -1,
	// 		minHeight: ~~ (this.canvas.height / 5 * 4 / 2),
	// 		maxHeight: ~~ (this.canvas.height / 5 * 5 / 2),
	// 		moveHeight: 0.1 * PX_RATIO,
	// 		directionHeight: 1,
	// 		minAngle: 300,
	// 		maxAngle: 320,
	// 		moveAngle: 0.03,
	// 		directionAngle: -1,
	// 	}
	// }
	// options_ellipses_sp() {
	// 	return {
	// 		x0: ~~ (this.canvas.width / 7 * 3),
	// 		y0: ~~ (this.canvas.height / 2),
	// 		color: '#fff',
	// 		// width: ~~ (this.canvas.width * PX_RATIO / 5 * 4 / 2),
	// 		minWidth: ~~ (this.canvas.width / 5 * 3 / 2),
	// 		maxWidth: ~~ (this.canvas.width / 5 * 4 / 2),
	// 		moveWidth: 0.1 * PX_RATIO,
	// 		directionWidth: -1,
	// 		minHeight: ~~ (this.canvas.height / 5 * 3 / 2),
	// 		maxHeight: ~~ (this.canvas.height / 5 * 4 / 2),
	// 		moveHeight: 0.05 * PX_RATIO,
	// 		directionHeight: 1,
	// 		minAngle: 300,
	// 		maxAngle: 320,
	// 		moveAngle: 0.03,
	// 		directionAngle: 1,
	// 	};
	// }
	set() {
		for (let i = 0; i < BUBBLE_INFOS.length; i++) {
			let _bubble = new Bubble(false);
			this.bubbles.push(_bubble);
		}
		// this.bubbles.push(new Bubble(true));
		// 楕円
		// this.ellipses.push(new Ellipse(windowType === 'h' ? this.options_ellipses_pc() : this.options_ellipses_sp()));
	}

	animate() {
		requestAnimationFrame(this.animate.bind(this));
		this.render();
	}

	render() {
		this.clear();
		this.context.save();
		// this.context.globalCompositeOperation = "luminosity";
		for (var i = 0; i < this.bubbles.length; i++) {
			this.bubbles[i].draw(this.context);
		}
		// for (var i = 0; i < this.ellipses.length; i++) {
		// 	this.ellipses[i].draw(this.context);
		// }
		this.context.restore();
	}
}

// class Ellipse {
// 	constructor(args) {
// 		this.x0 = args.x0;  // 回転の中心のx座標
// 		this.y0 = args.y0;  // 回転の中心のy座標
// 		this.color = args.color;    // 円の色
// 		const cw = window.innerWidth * PX_RATIO;
// 		const ch = window.innerHeight * PX_RATIO;
//         const cl = Math.max(cw, ch); // 画面サイズ（width, heightの長い方）
// 		// this.moveWidth = args.moveWidth;
// 		// this.move = MIN_SPEED;
// 		// this.width = args.width;

// 		// width
// 		this.directionWidth = args.directionWidth;
// 		this.minWidth = args.minWidth;
// 		this.maxWidth = args.maxWidth;
// 		this.width = this.directionWidth === 1 ? this.minWidth : this.maxWidth;
// 		this.moveWidth = args.moveWidth;

// 		// height
// 		this.directionHeight = args.directionHeight;
// 		this.minHeight = args.minHeight;
// 		this.maxHeight = args.maxHeight;
// 		this.height = this.directionHeight === 1 ? this.minHeight : this.maxHeight;
// 		this.moveHeight = args.moveHeight;
// 		this.directionAngle = args.directionAngle;

// 		// angle
// 		this.minAngle = args.minAngle;
// 		this.maxAngle = args.maxAngle;
//         this.angle = this.directionAngle === 1 ? this.minAngle : this.maxAngle;       // 度数
// 		this.moveAngle = args.moveAngle;      // 度数
// 		// this.radius = ~~ (cl / 8 * Math.random() + cl / 8);    // 描画する円の半径
//         // this.radiusOrbit = ~~ (cl / 2 * Math.random());
// 	}
// 	update() {
// 		// width
// 		if (this.directionWidth === 1 && this.maxWidth <= this.width) {
// 			this.directionWidth = -1;
// 		} else if (this.directionWidth === -1 && this.minWidth >= this.width) {
// 			this.directionWidth = 1;
// 		}
// 		this.width += this.directionWidth * this.moveWidth;

// 		// height
// 		if (this.directionHeight === 1 && this.maxHeight <= this.height) {
// 			this.directionHeight = -1;
// 		} else if (this.directionHeight === -1 && this.minHeight >= this.height) {
// 			this.directionHeight = 1;
// 		}
// 		this.height += this.directionHeight * this.moveHeight;

// 		// angle
// 		if (this.directionAngle === 1 && this.maxAngle <= this.angle) {
// 			this.directionAngle = -1;
// 		} else if (this.directionAngle === -1 && this.minAngle >= this.angle) {
// 			this.directionAngle = 1;
// 		}
// 		this.angle += this.directionAngle * this.moveAngle;
//         // console.log(this.angle);
// 	}
// 	draw(_ctx) {
// 		this.update();
// 		_ctx.beginPath();
// 		_ctx.fillStyle = this.color;
// 		// _ctx.ellipse(this.x0, this.y0, this.width, this.height, Math.PI/180 * this.angle, 0, PI2);
// 		// _ctx.globalAlpha = OPACITY;
// 		_ctx.fill();
// 		_ctx.closePath();
// 	}
// }


document.addEventListener('DOMContentLoaded', function(event) {
	// 背景エフェクト実行
	new Blubble('background-effect', COUNT_BUBBLES);
});